import { Address } from '@core/models';
import { parseUSAddress } from '@core/helpers';

export const MIN_ADDRESS_QUERY_LENGTH = 3;

/**
 * Formats client address model adding apartment/suite number and address name.
 */
export function formatClientAddress(
	rawAddress: string,
	apartment?: string | null,
	addressName?: string | null
): Address {
	const parsed = parseUSAddress(rawAddress || '');
	const apartmentSuffix = apartment ? `, #${apartment}` : '';
	const direccion2 = parsed.direccion2
		? `${parsed.direccion2}${apartmentSuffix}`
		: apartment
		? `#${apartment}`
		: '';

	return {
		...parsed,
		direccion2,
		nombre: addressName || 'Dirección sin nombre',
	} as Address;
}

/**
 * Concatenates street address and secondary line into a single display string.
 */
export function formatFullAddress(address: Address): string {
	const secondary = address.direccion2 ? `, ${address.direccion2}` : '';
	return `${address.direccion1 ?? ''}${secondary}`;
}

/**
 * Validates if the given text has sufficient length for address search or autocomplete.
 */
export function isValidAddressQuery(query?: string | null): boolean {
	if (!query) {
		return false;
	}
	return query.trim().length >= MIN_ADDRESS_QUERY_LENGTH;
}
